import styled from "styled-components";

import { Grid } from "@mui/material";
import BannerImg from "../../assets/cangoo-cotacao-banner.jpg"

export const BannerGrid = styled(Grid)`

background: url(${BannerImg});
background-repeat: no-repeat;
background-position: bottom center; 
background-size: cover; 

 padding-top: 24rem;
 padding-bottom: 10rem;


 @keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.title {
    position: relative;
    width: fit-content;
    display: flex;

    
    margin-left: 10rem;
    animation: fadeIn 2s ease-in-out;

    h1 {
        font-family: 'Nexa-Black'; 
        font-size: 8rem;
        color: ${({ theme }) => theme.COLORS.WHITE};
        letter-spacing: 1px;
        padding-right: 4rem;
        padding-bottom: 2rem;
    }

    img {
        width: 15rem;
        position: absolute;
        right: 0;
      
    }
}


@media (max-width: 1400px) {
   .title {

    h1 { 
        font-size: 5rem;
        padding-right: 3rem;
        
    }

    img {
        width: 10rem;  
        bottom: 0;
    }
   }
  }

 
  @media (max-width: 900px) {
    padding-top: 20rem;
    padding-bottom: 6rem;

   .title {
    margin-left: auto;
    margin-right: auto;

    h1 { 
        font-size: 4rem;
        padding-right: 3rem;
        padding-bottom: 2rem;
    }

    img {
        width: 8rem;  
        bottom: 0;
    }
   }
  }


  @media (max-width: 550px) {
   .title {
    padding-left: 1rem;
    padding-right: 1rem;

    h1 { 
        font-size: 3rem;
        padding-right: 1rem;
    }

    img {
        width: 6rem;  
        bottom: .5rem;
    }
   }
  }


 
`;


export const CotacaoGrid = styled(Grid)`
padding: 10rem 0;
animation: fadeIn 1s ease-in-out;


.texto {
   
    text-align: center;

    h1 {
        font-size: clamp(2.4rem, 3.4vw, 5.4rem); 
        font-family: 'Nexa-Bold';
        margin-bottom: 1.8rem;
        letter-spacing: 1px;
        color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
    }

    span {
        color: ${({ theme }) => theme.COLORS.YELLOW};
        font-size: clamp(2.4rem, 3.4vw, 5.4rem); 
        font-family: 'Nexa-Bold';
    }

    p {
        font-family: 'Mont-Light';
        font-size: clamp(1.6rem, 3.4vw, 3rem); 
    }
}


.form-cotacao {
    padding: 0 40rem;
    margin-top: 8rem;
    text-align: right;

    small { 
            color: ${({ theme }) => theme.COLORS.YELLOW};
            font-family: 'Mont-Medium';
            font-size: 1.4rem;
            bottom: -2rem;
            left: 26rem; 
        }

    .empresa-text {
        position: relative;

        small {
            position: absolute;
        }
      
    }

    .medidas-text {
        position: relative;

        small {
            position: absolute;
        }
    }

    .double-input {
        display: flex;
    }

    .line-top {
        border-top: 1px solid  ${({ theme }) => theme.COLORS.YELLOW};
        padding-top: 3rem;
    }

    .input {
        display: flex;
        align-items: center;
        margin-bottom: 3rem;

        label {
            color: ${({ theme }) => theme.COLORS.BLUE};
            font-family: 'Mont-Medium';
            font-size: clamp(1.6rem, 2vw, 2.6rem); 
            margin-right: 2rem;
            min-width: 22rem;
        }
    }

    .cidade {
        width: 100%;
    }

    .uf {
        label {
            min-width: 3rem !important;
            margin-left: 4rem;
        }
    }
}




@media (max-width: 1700px) {
.form-cotacao {
    padding: 0 30rem;
}
}

@media (max-width: 1500px) {
.form-cotacao {
    padding: 0 20rem;
}
}


@media (max-width: 1400px) {
  .texto {

    h1 {
        font-size: clamp(2.6rem, 3.4vw, 4.2rem);
    }

    span {
        font-size: clamp(2.6rem, 3.4vw, 4.2rem); 
    }

    p {
        font-size: clamp(1.8rem, 3.4vw, 2.2rem); 
    }
}


.form-cotacao {
    padding: 0 18rem;

    small {
        font-size: 1.2rem;
        bottom: -1.6rem;
        left: 22rem; 
    }

.input {
    label {
        font-size: clamp(1.6rem, 2vw, 2rem); 
        min-width: 18rem;
    }
}
}

}


@media (max-width: 1200px) {
    .form-cotacao {
        padding: 0 10rem;
    }
}


@media (max-width: 1100px) {
    .form-cotacao {
        padding: 0 6rem;
    }
}

@media (max-width: 1000px) {
    .form-cotacao {
        padding: 0 4rem;

        .input {
    label {
        
        min-width: 17rem;
    }
}
    }
}


@media (max-width: 900px) {
padding: 10rem 3rem;

    .form-cotacao {
    padding: 0;

    small {
        font-size: 1.2rem;
        bottom: -1.6rem;
        left: 1rem; 
    }

    .line-top {
        padding-top: 2rem;
        margin-top: 4rem;
    }

    .input {
     margin-bottom: 2rem;

     text-align: left;
     align-items: start;
     flex-direction: column;

        label {
         margin-bottom: 1rem;
        }
    }

    .cidade {
        width: 120%;
       padding-right: 2rem;
    }

    .uf {
        label {
          margin-left: 0;
        }
    }
}
}


@media (max-width: 600px) {
    padding: 10rem 1.4rem;
  padding-top: 6rem;
}

@media (max-width: 400px) {
   .form-cotacao {
    small {
        font-size: 1rem; 
    }
   }
}



`;



export const FormInput = styled.input`
width: 100%;
padding: 1rem 2rem;
font-size: 2rem;


border-radius: 999px;
border: 1px solid;

border-color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};

color: ${({ theme }) => theme.COLORS.DARKGREY};
font-family: 'Mont-Light';

&:hover {
    outline: 1px solid ${({ theme }) => theme.COLORS.LIGHTBLUE1};
}

&:focus {
    outline: 1px solid ${({ theme }) => theme.COLORS.LIGHTBLUE1};
}


@media (max-width: 1400px) {
    font-size: clamp(1.4rem, 2vw, 1.8rem); 
}

@media (max-width: 500px) {
    padding: 1rem 1.2rem;
}

`;



export const ButtonWrapper = styled.div`
text-align: center;
`;


export const FormButton =styled.button`
    padding: 1.3rem 15%;
    border: none;
    border-radius: 999px;
    margin-top: 3rem;
    margin-left: auto;
    margin-right: auto;

    background-color:${({ theme }) => theme.COLORS.YELLOW};
    color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
    font-size: clamp(2.6rem, 2vw, 4rem);
    font-family: 'Nexa-Bold'; 
    letter-spacing: 1px;

    transition: all .2s;
    
    &:hover {
        background-color:${({ theme }) => theme.COLORS.LIGHTBLUE2};
        color: ${({ theme }) => theme.COLORS.YELLOW};
    }
    
`;
